import { Injectable } from '@angular/core';
import { merge } from 'lodash';
import { ConditionalTypeEnum } from 'src/app/components/widgets/metadata-template/metadata-template.component';

@Injectable({
  providedIn: 'root',
})
export class MetadataTemplateService {
  /**
   * Called when we
   * @param modifiedTemplate Structure that contains a string template
   *    along with conditional related properties
   */
  getModifiedTemplate(modifiedTemplate, data) {
    const newData = data;
    if (modifiedTemplate && modifiedTemplate != '') {
      const oldTemplate = data.template ? JSON.parse(data.template) : {};
      const newTemplate = JSON.parse(modifiedTemplate.template);

      // Lodash deep merge. Spread is not enough
      const mergedTemplate = merge(oldTemplate, newTemplate);

      // Create output structure
      newData.template = JSON.stringify(mergedTemplate);
      newData.conditionalType = modifiedTemplate.conditionalType;
      newData.relatedPrimitive = modifiedTemplate.relatedPrimitive;
      newData.primitiveOption = modifiedTemplate.primitiveOption;
    }
    return newData;
  }

  /**
   * hide based on one option
   * @param value
   * @param key
   * @param type
   * @param label
   * @returns
   */
  createNewTemplate(conditionalType: ConditionalTypeEnum, value, key, type, label) {
    let newTemplate = '';

    if (conditionalType === ConditionalTypeEnum.HideForOption) {
      if (type === 'radio') {
        newTemplate = `{"expressions": {"hide": "!(model && model.${key}!== undefined && model.${key}!=='${value}')" } }`;
      } else if (type === 'checkbox') {
        newTemplate = `{ "expressions": {"hide":"!(model && model.${key} !== undefined && model.${key}.${value} !== true)" }}`;
      } else if (type === 'input') {
        if (label === 'Populated') {
          newTemplate = `{"expressions":{"hide":"(model === undefined || !model.${key}${value})"} }`;
        } else {
          newTemplate = `{"expressions":{"hide":"(model && model.${key}=== undefined || model.${key}${value})"} }`;
        }
      }
    } else if (conditionalType === ConditionalTypeEnum.ShowForOption) {
      if (type === 'radio') {
        newTemplate = `{"expressions": {"hide": "(model && model.${key}!== undefined && model.${key}!=='${value}')" } }`;
      } else if (type === 'checkbox') {
        newTemplate = `{ "expressions": {"hide":"(model && model.${key} !== undefined && model.${key}.${value} !== true)" }}`;
      } else if (type === 'input') {
        if (label === 'Populated') {
          newTemplate = `{"expressions":{"hide":"!(model === undefined || !model.${key}${value})"} }`;
        } else {
          newTemplate = `{"expressions":{"hide":"!(model && model.${key}=== undefined || model.${key}${value})"} }`;
        }
      }
    } 

    return newTemplate;
  }
}
